import type { PipeTransform } from '@angular/core';

import { Pipe } from '@angular/core';

@Pipe({ name: 'toString', standalone: true })
export class ToStringPipe implements PipeTransform {
  transform(id: string | string[]): string {
    return id.toString();
  }
}
